module.exports = __webpack_public_path__ + "img/19c486d.svg";